import React from 'react';
import styles from './CustomNode.module.scss';
import TreeEditorConfig from '../../TreeEditorConfig';
import TeamGoalNode from '../GoalNode/TeamGoalNode/TeamGoalNode';
import GroupNode from '../GroupNode/GroupNode';
import FormGoalNode from '../FormGoalNode/FormGoalNode';
import AdministratorGoalNode from '../GoalNode/AdministratorGoalNode/AdministratorGoalNode';

export default function CustomNode(props) {
  const { nodeDatum, isEditable: initialIsEditable, variant, teamId } = props;
  const {
    attributes: { nodeType, id, isTeamGoal },
  } = nodeDatum;
  let node;
  const isTeamGoalHierarchy = !!teamId;

  switch (nodeType) {
    case 'GROUP':
      node = <GroupNode key={id} nodeDatum={nodeDatum} />;
      break;
    case 'GOAL':
      if (variant === 'form') {
        node = (
          <FormGoalNode
            key={id}
            nodeDatum={nodeDatum}
            isEditable={initialIsEditable && (!isTeamGoalHierarchy || isTeamGoal)}
            isTeamGoalHierarchy={teamId}
          />
        );
        break;
      }
      if (teamId) {
        node = <TeamGoalNode key={id} nodeDatum={nodeDatum} teamId={teamId} variant={variant} />;
        break;
      }
      node = <AdministratorGoalNode key={id} nodeDatum={nodeDatum} variant={variant} />;
      break;
  }

  return (
    <foreignObject
      x={TreeEditorConfig[variant].nodeSize.x / -2}
      y={TreeEditorConfig[variant].nodeSize.y / -2}
      width={TreeEditorConfig[variant].nodeSize.x}
      height={TreeEditorConfig[variant].nodeSize.y}
    >
      <div className={styles.node}>{node}</div>
    </foreignObject>
  );
}
